module.exports = __webpack_public_path__ + "static/media/map.a10dbeb9.png";